export const AddressNoteMaxLength = 40;
export const AddressNoteControlName = 'AddressNote';
export const AddressNoteLabel = 'Коментар до адреси';
export const AddressNotePlaceholder = '';
export const AddressNoteClasses = 'form-col w-100';
export const AddressNotePattern = /^[а-яА-Я,ёЁіІїЇєЄґҐюЮ\d\s.№'*`/()\-+"«»]*$/;
export const AddressNoteExtendedPattern = /^[а-яА-Я,ёЁіІїЇєЄґҐюЮa-zA-Z\d\s.№'*`/()\-+"«»!#&/:\\]*$/;
